import {
  getDominateFunction,
  getAuxililaryFunction,
  getTertiaryFunction,
  getInferiorFunction,
  getAbsentFunctions,
  getAllFunctions,
  getTraits,
  isValidMBTI,
  functionKeywords,
  definitions
} from "./functions"
import { toJS } from "mobx"

// // http://materialuicolors.co/
// blue, green, red
const colors = ["#80D8FF", "#69F0AE", "#FF5252", "#EA80FC", "#FFAB40"]

export default {
  order: 0,
  name: "Mark Johnson",
  mbti: "INTP",
  color: "#fff",
  get valid() {
    // todo: make more valid
    return this.mbti.length === 4
  },
  get funcs() {
    return [
      getDominateFunction(this.mbti),
      getAuxililaryFunction(this.mbti),
      getTertiaryFunction(this.mbti),
      getInferiorFunction(this.mbti)
    ]
  },
  get attributes() {
    return getTraits(this.mbti)
  },
  get chartTraits() {
    return this.attributes.map(a => {
      return { axis: a.name, value: a.weight, definition: a.definition }
    })
  },
  isValidMBTI(mbti) {
    return isValidMBTI(mbti)
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js